module.exports = __webpack_public_path__ + "static/media/krx-storyboard.fbd919fd.jpg";